module.exports = __webpack_public_path__ + "static/media/festival-sc.b29f269c.jpg";